import { useCurrentUser } from 'javascripts/hooks';
import CCEvents, { EventNames } from '@companycam/companycam-events';
import apiClient from 'apiClient';
import { userHasPermission, ACCESS_REPORTS } from 'helpers/permissions';
import { canAccessFeature, FEATURES } from 'helpers/features';
import useCompanyBillingStatus from 'components/billing/useCompanyBillingStatus';
import { useModal } from 'components/shared/hooks';
import { Modal } from 'components/core/modal/constants';

const NO_ACTION = null;
const NO_MODAL = () => {};
const EMPTY_RESULT = [NO_ACTION, NO_MODAL];

const databaseIdFrom = (obj) => parseInt(obj.databaseId, 10);

export default function useMenuActionCreateReport({ assetsByType }) {
  const user = useCurrentUser();
  const { featureSet } = useCompanyBillingStatus();
  const { showModal, hideModal } = useModal();
  const hasPermission = userHasPermission(user, ACCESS_REPORTS);
  const canAccessReportGeneration = canAccessFeature(
    featureSet,
    FEATURES.REPORT_GENERATION,
  );
  const validSelection = assetsByType.photos.length > 0;

  if (!hasPermission || !validSelection) {
    return EMPTY_RESULT;
  }

  const action = () => {
    const params = {
      report: {
        user_id: user.id,
        image_ids: assetsByType.photos.map(databaseIdFrom),
      },
    };

    apiClient
      .post(`companies/${user.company_id}/reports`, params)
      .then(({ id }) => {
        // Log create report event
        CCEvents.logEvent(EventNames.CREATE_REPORT);
        document.location.href = `/reports/${id}/edit`;
      });
  };

  const actionOrUpgrade = canAccessReportGeneration
    ? action
    : () =>
        showModal(Modal.UPGRADE_REPORTS, {
          onRequestClose: () => hideModal(),
        });

  return [actionOrUpgrade, canAccessReportGeneration, NO_MODAL];
}
